const images = {
Logo: require('../images/media/logo.png'),
home: require('../images/media/home.png')
}

export default images;